module.exports = __webpack_public_path__ + "img/menu_icon.79b18a5d.png";